import React, { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import moment from 'moment';
import "bootstrap-daterangepicker/daterangepicker.css";
import { Dropdown, Tab, Nav, Modal, Button } from "react-bootstrap";
import { get_User_data, get_AstrologerSingleData, get_AstroData, get_UserData, get_AdminSingleData } from '../../../store/actions/CommanAction';
import { useDispatch, useSelector } from 'react-redux';
import { setAstroId, setAdminId } from '../../../store/Action_Types';
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import swal from "sweetalert";
import DataTable from 'react-data-table-component';
import { customStyles } from '../Utility/Utility';
import user from './../../../images/task/user.jpg';
import { ColorSelectorView } from 'ckeditor5';
import Loader from '../Loader/Loader';
import AdminUser from './AdminUser';

const AdminUserList = () => {
    const dispatch = useDispatch();
    const AstroData = useSelector((state) => state.feedBackReducer.GetDataUsers);
    const customerID = Number(sessionStorage.getItem('ID'));
    const AstrologerSingleData = useSelector((state) => state.feedBackReducer.AstrologerSingleData);
    const [showModal, setShowModal] = useState(false);
    const [editingId, setEditingId] = useState(null);

    const selectedAstroId = useSelector((state) => state.feedBackReducer.selectedAstroId);
    const [IsActive, setIsActive] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [AstrologerID, seAstrologerID] = useState('');
    const [EditModalAstro, setEditModalAstro] = useState(false);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [searchQuery1, setSearchQuery1] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [name, setName] = useState("");
    const [location, setLocation] = useState("");
    const [loading, setloading] = useState(false);
    //-------------------------Review-------------------------
    const [ReviewData, setReviewData] = useState({
        'AstrologerID': AstrologerID, 'OriginalPricePerMin': '', 'PricePerMin': '', 'Reviews': '', 'Rating': '', 'ModifiedByUser': '1',
    });


    const handleAddAstrologerClick = (ID) => {
        setEditingId(ID || null);
        setShowModal(true);
        if (ID) {
            dispatch(setAdminId(ID));
            dispatch(get_AdminSingleData(ID));
        } else {
            // Reset form for new user
            dispatch(setAdminId(null));
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setEditingId(null);
    };

    const handleUserUpdated = () => {
        setShowModal(false);
        // Refresh the user list
        const today = new Date();
        const formattedToday = today.toISOString().split('T')[0];
        dispatch(get_User_data(setloading, IsActive ? '1' : '0', formattedToday, formattedToday, name, mobileNumber, location));
    };
    useEffect(() => {
        seAstrologerID(AstrologerID)
    }, [AstrologerID])

    useEffect(() => {
        if (IsActive) {
            const today = new Date();
            const formattedToday = today.toISOString().split('T')[0];
            const CreatedFrom = formattedToday;
            const CreatedTo = formattedToday;
            const IsActive = "1"
            setStartTime(CreatedFrom);
            setEndTime(CreatedTo);



            dispatch(get_User_data(setloading, IsActive, CreatedFrom, CreatedTo, name, mobileNumber, location));
            // dispatch(get_User_data(IsActive));
        } else {

            const today = new Date();
            const formattedToday = today.toISOString().split('T')[0];
            const CreatedFrom = formattedToday;
            const CreatedTo = formattedToday;
            const IsActive = "0";
            setStartTime(CreatedFrom);
            setEndTime(CreatedTo);
            dispatch(get_User_data(setloading, IsActive));
            dispatch(get_User_data(setloading, IsActive, CreatedFrom, CreatedTo, name, mobileNumber, location));
        }
    }, []);

    const filteredAstroData = AstroData?.filter(item => {
        const query = searchQuery ? searchQuery.toLowerCase() : '';
        return (
            (item.DisplayName && item.DisplayName.toLowerCase().includes(query)) ||
            (item.EMPID && item.EMPID.toLowerCase().includes(query)) ||
            (item.RegMobileNo && item.RegMobileNo.toLowerCase().includes(query)) ||
            (item.EmailID && item.EmailID.toLowerCase().includes(query))
        );
    });

    const handleToggleStatusClick = async (AdminID, currentStatus, isActiveValue) => {
        const postData = {
            'Id': AdminID,
            'DeleteByUser': customerID,
            IsActive: !currentStatus ? '1' : '0',
        };
        await AddUpdate('Users/UsersDelete', postData);
        dispatch(get_User_data(setloading, currentStatus ? '1' : '0'));
        swal('Good job!', `Successfully ${isActiveValue === '1' ? 'Active' : 'Inactive'}`, "success");

    };




    const handleSearch = (IsActive) => {

        if (mobileNumber.trim() && !/^\d{10}$/.test(mobileNumber)) {
            alert("Mobile number must be exactly 10 digits and numbers.");
            return;
        }

        if (name.trim() && !/^[a-zA-Z\s]+$/.test(name.trim())) {
            alert("Name must be in a valid string format.");
            return;
        }

        if (location.trim() && !/^[a-zA-Z\s]+$/.test(location.trim())) {
            alert("Location must be in a valid string format.");
            return;
        }

        const formatDate = (dateTime) => {
            if (!dateTime) return null;
            const date = new Date(dateTime);
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd}`;
        };

        const formattedStartDate = formatDate(startTime);
        const formattedEndDate = formatDate(endTime);

        // const isActive = IsActive ? "0" : "1";
        const CreatedFrom = formattedStartDate;
        const CreatedTo = formattedEndDate;

        dispatch(get_User_data(setloading, IsActive, CreatedFrom, CreatedTo, name, mobileNumber, location));

    };


    const columns = [

        {
            name: 'Image',
            cell: row => (
                <div className="concierge-bx d-flex align-items-center  ">
                    {
                        row.Photourl ? (
                            <img className="me-3 rounded" src={`https://${row.Photourl.replace(/\\/g, "/")}`} alt="User Avatar" />
                        ) :
                            <img className="me-3 rounded" src={user} />
                        //  (<span className="me-3 rounded"></span>)
                    }
                </div>
            ),
            sortable: true
        },
        {
            name: 'Name',
            cell: row => (
                <div style={{ marginRight: "60px" }}>

                    <h5 className="fs-16 mb-0 text-nowrap">
                        <Link to={"/adminuser"} onClick={() => { handleAddAstrologerClick(row.ID); }} className="text-black"   >
                            {row.UserName}
                        </Link>
                    </h5>
                    {/* <span className="text-primary fs-14 ">{row.EMPID}</span> */}
                </div>
            ),
            sortable: true
        },
        { name: 'Name', selector: (row) => row.UserName, sortable: true },
        { name: 'Mobile Number', selector: (row) => row.MobileNo, sortable: true },
        { name: 'Address', selector: (row) => row.Address, sortable: true },





        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => (
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            {/* <Dropdown.Item onClick={() => handleEditClick(row)} >Reviews/Rating</Dropdown.Item> */}
                            <Dropdown.Item className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => { handleToggleStatusClick(row.ID, true, '0'); }}>
                                Inactive
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            )
        }
    ];

    const columns1 = [
        {
            name: 'Image',
            cell: row => (
                <div className="concierge-bx d-flex align-items-center  ">
                    {
                        row.Photourl ? (
                            <img className="me-3 rounded" src={`https://${row.Photourl.replace(/\\/g, "/")}`} alt="User Avatar" />
                        ) :
                            <img className="me-3 rounded" src={user} />
                        //  (<span className="me-3 rounded"></span>)    
                    }
                </div>
            ),
            sortable: true
        },
        {
            name: 'Name',
            cell: row => (
                <div style={{ marginRight: "60px" }}>

                    <h5 className="fs-16 mb-0 text-nowrap">
                        <Link to={"/adminuser"} onClick={() => { handleAddAstrologerClick(row.ID); }} className="text-black"   >
                            {row.UserName}
                        </Link>
                    </h5>
                    {/* <span className="text-primary fs-14 ">{row.EMPID}</span> */}
                </div>
            ),
            sortable: true
        },
        { name: 'Name', selector: (row) => row.UserName, sortable: true },
        { name: 'Mobile Number', selector: (row) => row.MobileNo, sortable: true },
        { name: 'Address', selector: (row) => row.Address, sortable: true },

        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => (
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.ID, false, '1');
                                }}>
                                Activate
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            )
        }
    ];

    const handleEditClick = (row) => {
        dispatch(get_AstrologerSingleData(AstrologerID)); seAstrologerID(row?.ID); setReviewData(AstrologerSingleData); setEditModalAstro(true);
    };

    useEffect(() => {
        if (AstrologerSingleData && AstrologerSingleData.length > 0) {
            setReviewData({
                ...ReviewData,
                AstrologerID: AstrologerID, 'OriginalPricePerMin': AstrologerSingleData[0]?.OriginalPricePerMin, 'PricePerMin': AstrologerSingleData[0]?.PricePerMin,
                'Reviews': AstrologerSingleData[0]?.Reviews, 'Rating': AstrologerSingleData[0]?.Rating,
            });
        }
    }, [AstrologerSingleData, AstrologerID]);

    const UpdateAstro = async (e) => {
        let error = false; let errorMsg = '';
        if (ReviewData.OriginalPricePerMin === "") {
            error = true; errorMsg = 'Please fill OriginalPricePerMin.';
        }
        else if (ReviewData.Reviews === "") {
            error = true; errorMsg = 'Please fill Reviews.';
        } else if (ReviewData.Rating === "") {
            error = true; errorMsg = 'Please fill Rating..';
        }
        if (!error) {
            await AddUpdate('Astrologer/UpdateAstrologerReview', ReviewData);
            swal('Good job!', 'Successfully Updated', "success");
            setEditModalAstro(false);
        } else {
            swal('Oops', errorMsg, "error");
        }
    };

    const handleChange = (e) => {
        if (e.target.name === 'Reviews' || e.target.name === 'OriginalPricePerMin' || e.target.name === 'Rating' || e.target.name === 'PricePerMin') {
            const ele = e.target.value.replace(/[^0-9.]/g, "")
            if (ele.includes('.')) {
                if (ele.length === 16) {
                    setReviewData({ ...ReviewData, [e.target.name]: ele });
                } else {
                    if (ele.substr(ele.indexOf('.') + 1).slice(0, 2)) {
                        const checkDot = ele.substr(ele.indexOf('.') + 1).slice(0, 2).match(/\./g)
                        if (!checkDot) {
                            setReviewData({ ...ReviewData, [e.target.name]: ele.substring(0, ele.indexOf(".")) + '.' + ele.substr(ele.indexOf('.') + 1).slice(0, 2) });
                            return;
                        } else { return; }
                    } else { setReviewData({ ...ReviewData, [e.target.name]: ele }) }
                }
            } else { setReviewData({ ...ReviewData, [e.target.name]: ele }); }
        }
    }




    return (
        <>
           


            <Tab.Container defaultActiveKey="All">
                <div className='main_card mb-2'>
                    <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Admin User List</h2>
                    <div className="mt-2 d-flex justify-content-between align-items-center flex-wrap">
                        <div className="card-action coin-tabs mb-2">
                            <Nav variant="tabs">
                                <Nav.Item as="li" className="nav-item">
                                    <Nav.Link
                                        className={`nav-link ${IsActive ? 'active' : ''}`}
                                        onClick={() => {
                                            setIsActive(true);
                                            setSearchQuery('');
                                            handleSearch(true)

                                        }}
                                    >
                                        Active
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" className="nav-item">
                                    <Nav.Link
                                        className={`nav-link ${!IsActive ? 'active' : ''}`}
                                        onClick={() => {
                                            setIsActive(false);
                                            setSearchQuery('');
                                            handleSearch(false)

                                        }}
                                    >
                                        Inactive
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </div>
                        <button onClick={() => handleAddAstrologerClick(null)} className="btn btn-primary font-w600 mb-2 text-center">
                        Add Admin User
                    </button>

                    {/* Admin User Modal */}
                    <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" centered>
                        <Modal.Header closeButton>
                            <Modal.Title>{editingId ? 'Edit Admin User' : 'Add New Admin User'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <AdminUser 
                                onUserUpdated={() => {
                                    setShowModal(false);
                                    // Refresh the user list after update
                                    dispatch(get_User_data());
                                }} 
                            />
                        </Modal.Body>
                    </Modal>

                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <Tab.Content>
                                    <Tab.Pane eventKey="All">
                                        <div className="table-responsive">
                                            {
                                                IsActive ?
                                                    <>{loading ? (
                                                        <Loader />
                                                    ) : (
                                                        <DataTable
                                                            dense
                                                            columns={columns}
                                                            data={AstroData}
                                                            selectableRowsHighlight
                                                            highlightOnHover
                                                            pagination
                                                            persistTableHead={true}
                                                            noDataComponent={"There are no data to display"}
                                                            customStyles={customStyles}
                                                        />)}
                                                    </>
                                                    :
                                                    <>{loading ? (
                                                        <Loader />
                                                    ) : (
                                                        <DataTable
                                                            dense
                                                            data={AstroData}
                                                            columns={columns1}
                                                            pagination
                                                            persistTableHead={true}
                                                            noDataComponent={"There are no data to display"}
                                                            customStyles={customStyles}

                                                        />)}
                                                    </>
                                            }
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </div>
                </div>

            </Tab.Container >
        </>
    )
}
export default AdminUserList